import mqtt from 'mqtt'
import {getToken, removeToken} from '../utils/auth'
import { Notification, MessageBox } from 'element-ui'
import store from '../store/store'

let client = null
let mqtts = []
function getapi () {
  let host = window.location.host
  let aaa = ''
  if (window.location.protocol === 'http:') {
    aaa = 'ws://' + host + '/wss/'
  } else {
    aaa = 'wss://' + host + '/wss/'
  }
  let arr = host.split(':')
  if (arr[0] === 'localhost' || arr[0] === '10.0.0.8') {
    return 'wss://kangnh.com/wss/'
    // return 'wss://jiaold.com/wss/'
  } else {
    return aaa
  }
}
// let member = 0
// 开启订阅（登录成功后调用）
export const startSub = (vm) => {
  mqtts = vm.$store.state.user.mqtts
  let mqttlevel = vm.$store.state.user.sipinfo.mqttlevel
  let role = vm.$store.state.user.role
  let syspersonid = vm.$store.state.user.syspersonid
  let customerservicetag = vm.$store.state.user.customerservicetag
  let csdMqtt = ''
  console.log('mqtts', customerservicetag, mqtts, mqttlevel)
  let member = 0
  if (client === null) {
    var options = {
      clientId: 'mqttnewhealth',
      username: getToken(),
      password: getToken(),
      timeout: 5,
      keepAliveInterval: 50,
      cleanSession: false,
      useSSL: false
    }
    client = mqtt.connect(getapi(), options)
    client.on('connect', () => {
      // 订阅消息类通知主题
      if (mqtts && mqtts.length !== 0) {
        client.subscribe('/handleorder' + mqtts[0])
        client.subscribe('/handleorder' + mqtts[0] + '/#')
        client.subscribe('/handledoneorder' + mqtts[0])
        client.subscribe('/handledoneorder' + mqtts[0] + '/#')
        client.subscribe('/handlealarm' + mqtts[0])
        client.subscribe('/handlealarm' + mqtts[0] + '/#')
        client.subscribe('/handledone' + mqtts[0])
        client.subscribe('/handledone' + mqtts[0] + '/#')
        for (let i = 0; i < mqtts.length; i++) {
          client.subscribe(mqtts[i])
          const alllevel = mqtts[i] + '/#'
          client.subscribe(alllevel)
        }
      }
      // 拨打电话
      client.subscribe('callphone' + mqtts[0])
      client.subscribe('callphonedone' + mqtts[0])
      // 即构视频
      // client.subscribe('/1/3/1312')
      client.subscribe('callvideo' + mqtts[0])
      if (mqttlevel) {
        client.subscribe(mqttlevel)
      }
      if (role === 'csd') {
        csdMqtt = '/csd/' + syspersonid
        client.subscribe(csdMqtt)
      }

      console.log('连接mqtt成功，并已订阅相关主题')
    }).on('error', err => {
      console.log('连接mqtt报错', err)
      member += 1
      client.end()
      if (member < 5) {
        console.log('1s')
        setTimeout(() => {
          client.reconnect()
        }, 1000)
      } else if (member === 5) {
        console.log('5s')
        setTimeout(() => {
          client.reconnect()
        }, 5000)
      } else {
        console.log('5s之后重启')
        MessageBox.confirm('您长时间未进行操作，请您刷新页面或重新登录。', '', {
          closeOnClickModal: false,
          showClose: false,
          confirmButtonText: '重新登录',
          cancelButtonText: '刷新页面',
          type: 'warning'
        }).then(() => {
          removeToken()
          store.commit('set_path', true)
          location.href = '/'
        }).catch(() => {
          window.location.reload()
        })
      }
    }).on('message', (topic, message) => {
      let msg = message.toString()
      let msgJSON = JSON.parse(msg)
      // console.log(mqtts)
      // console.log('收到消息', topic, msgJSON)
      // debugger
      if (mqtts && mqtts.length !== 0) {
        if (topic === ('/handleorder' + mqtts[0])) {
          // console.log('收到服务商接单', topic, message.toString())
          vm.store2.dispatch('company/update_company_handle', msgJSON).then(() => {
            vm.golobleObject.getDoneOder()
          })
          return
        } else if (topic === ('/handledoneorder' + mqtts[0])) {
          vm.store2.dispatch('company/update_del_company_handle', msgJSON.id).then(() => {
            vm.golobleObject.updateTableOrder()
          })
          return
        } else if (topic === ('/handlealarm' + mqtts[0])) {
          // console.log(333, '处理报警', msgJSON)
          vm.store2.dispatch('other/update_is_handle', msgJSON).then(() => {
            if (vm.$store.state.user.isShangHai) { // 上海
            } else { // 中性
              if (vm.$route.path === '/monitor') {
                // 右下角
                vm.golobleObject.monitorAlarm(msgJSON)
              }
            }
            if (vm.$route.path === '/handleAlarm' || vm.$route.path === '/monitor' || vm.$route.path === '/dealAlarm' || vm.$route.path === '/eventMonitor') {
              vm.golobleObject.getHandleInfo()
            }
          })
          return
        } else if (topic + '' === ('/handledone' + mqtts[0])) {
          // console.log(444, '处理完成', msgJSON)
          if (vm.$route.path === '/monitor') {
            vm.golobleObject.clearMapMaker(msgJSON.id) // 清除地图上的点
          }
          vm.store2.dispatch('other/update_del_handle', msgJSON.id).then(() => {
            if (vm.$route.path === '/handleAlarm' || vm.$route.path === '/monitor' || vm.$route.path === '/dealAlarm' || vm.$route.path === '/eventMonitor') {
              vm.golobleObject.updateTableAlarm() // 重新获取数据（更新初始化接口）
            }
          })
          vm.store2.dispatch('other/update_del_alarm', msgJSON.id).then(() => {})
          return
        }
      }

      if (topic + '' === 'callphone' + mqtts[0]) {
        // console.log('555收到拨打电话信息', msgJSON)
        vm.store2.dispatch('other/update_is_call', msgJSON).then(() => {
          if (vm.$route.path === '/customerService') {
            vm.golobleObject.getCallInfo()
          }
        })
      } else if (topic + '' === 'callphonedone' + mqtts[0]) {
        // console.log(666, '拨打电话完成')
        vm.store2.dispatch('other/update_del_call', msgJSON.id).then(() => {
          if (vm.$route.path === '/customerService') {
            vm.golobleObject.updateTableC()
          }
        })
      } else if (topic + '' === mqttlevel) {
        // console.log(777, '收到sip信息')
        let phoneEvent = ''
        if (msgJSON.callevent === 'ringing') {
          phoneEvent = '振铃'
        }
        if (msgJSON.callevent === 'answer') {
          phoneEvent = '正在接听'
          if (mqttlevel.slice(0, 5) === '/call') {
            if (msgJSON.alarmtype === 'phoneout') {
              vm.store2.dispatch('other/update_call_out', msgJSON).then(() => {})
            } else if (msgJSON.alarmtype === 'phonein') {
              vm.golobleObject.phoneInCall(msgJSON)
            }
          }
        }
        if (customerservicetag !== 2) {
          Notification({ title: phoneEvent, message: '电话号码：' + msgJSON.phone, type: 'success', duration: 1200 })
        }
        if (msgJSON.sessionid) {
          vm.golobleObject.updatePhone(msgJSON.sessionid)
        }
      } else if (topic + '' === csdMqtt) { // 转让订单
        // console.log(888, '转让订单')
        if (customerservicetag === 1) {
          vm.golobleObject.updateAlarmById(msgJSON)
        } else {
          vm.store2.dispatch('other/update_alarm_info', msgJSON).then(() => {
            if (vm.$route.path === '/handleAlarm') { // 事件处理 页面
              vm.golobleObject.updateTableAlarm()
            }
          })
        }
      } else if (topic + '' === 'callvideo' + mqtts[0]) {
        // console.log('mqtt已接听', msgJSON)
        let aa = {
          datatype: 'callvideo',
          deviceid: msgJSON.deviceid,
          roomid: msgJSON.roomid,
          result: msgJSON.result
        }
        vm.golobleObject.mqttVideoCall(aa)
      } else {
        // console.log('收到信息', topic, msgJSON)
        if (msgJSON.datatype === 'micromsg') {
          // console.log(999, '微聊（语音）通知刷新')
          if (vm.$route.path !== '/deviceGroupChat') {
            Notification({ title: '警告', message: '已收到微聊信息，请妥善处理。', type: 'warning', duration: 3000 })
          }
          vm.golobleObject.mqttChat(msgJSON)
          return
        }
        if (msgJSON.datatype === 'rtccallin') { // 即构视频首页弹窗
          // console.log('mqtt:rtccallin', msgJSON)
          Notification({ title: '提示', message: '您有一条视频呼入。', type: 'warning', duration: 3000 })
          vm.golobleObject.mqttVideoCall(msgJSON)
          return
        } else if (msgJSON.datatype === 'rtccalloutresult' || msgJSON.datatype === 'rtccalltime') { // 即构视频页面
          // console.log('mqtt:rtccalloutresult', msgJSON)
          //  0 接听，1拒接，2对方忙, 3对方未接
          if (parseInt(msgJSON.resulttype) === 1 || parseInt(msgJSON.resulttype) === 2 || parseInt(msgJSON.resulttype) === 3) {
            vm.$store.commit('set_is_mqtt', false)
            vm.store2.dispatch('other/update_zg_info', '')
            vm.golobleObject.mqttVideoCall(msgJSON)
          }
          if (vm.$route.path === '/videoZg') {
            vm.golobleObject.mattVideoCallPage(msgJSON)
          }
          return
        }
        if (msgJSON.datatype === 'healthdata') {
          if (msgJSON.healthdatatype === 'sleepingbag' || msgJSON.healthdatatype === 'sleepinguwb' || msgJSON.healthdatatype === 'breath' || msgJSON.healthdatatype === 'heartrate') { // 睡眠带 and 睡眠仪 心率、呼吸
            // console.log('睡眠带', msgJSON)
            if (vm.$route.path === '/healthDetection' || vm.$route.path === '/healthPage') { // 健康监控 页面 心率、呼吸
              vm.golobleObject.updateTableAlarm(msgJSON)
            }
          }
          if (msgJSON.healthdatatype === 'sphygmomanometer') { // 血压测量后,需要 健康数据 页面弹窗选择人员
            // console.log('血压', msgJSON)
            if (vm.$route.path === '/healthData') { // 健康数据 页面
              vm.golobleObject.updateTableAlarm(msgJSON)
            }
          }
          return
        }
        // 睡眠数据
        if (msgJSON.datatype === 'sleepstatus' && (vm.$route.path === '/healthDetection' || vm.$route.path === '/healthPage')) { // 406 612 613设备
          // console.log('睡眠数据', topic, msgJSON)
          vm.golobleObject.updateTableAlarm(msgJSON)
        }
        // 雷达数据
        if (msgJSON.datatype === 'radarstatus' && (vm.$route.path === '/healthDetection' || vm.$route.path === '/healthPage')) {
          // console.log('雷达数据', topic, msgJSON)
          vm.golobleObject.updateTableAlarm(msgJSON)
        }
        if (msgJSON.datatype === 'face') {
          if (vm.$route.path === '/cashierDesk') { // 健康数据 页面
            vm.golobleObject.updateTableAlarm(msgJSON)
          } else {
            vm.$router.push({path: '/cashierDesk'})
            setTimeout(() => {
              vm.golobleObject.updateTableAlarm(msgJSON)
            }, 1500)
          }
          return
        }
        // console.log(1000, '报警推送')
        if (msgJSON.alarmtype === 'phonein') {
          if (customerservicetag !== 2) {
            vm.golobleObject.getAudioPlay()
            Notification({title: '警告', message: '电话呼入提醒', type: 'warning', duration: 3000})
          }
        } else {
          console.log('收到信息', topic, msgJSON)
          // 雷达数据属于警报数据
          if (msgJSON.datatype === 'alarm' && msgJSON.alarmtype !== 'human_exist' && msgJSON.alarmtype !== 'human_not_exist' && msgJSON.alarmtype !== 'stranded_alarm') {
            vm.golobleObject.getAudioPlay(msgJSON)
            Notification({title: '警告', message: '已收到警报，请妥善处理。', type: 'warning', duration: 5000})
          }
        }
        if (msgJSON.datatype === 'alarm' && msgJSON.alarmtype !== 'human_exist' && msgJSON.alarmtype !== 'human_not_exist') {
          vm.store2.dispatch('other/update_alarm_info', msgJSON).then(() => {
            if (vm.$route.path === '/handleAlarm' || vm.$route.path === '/dealAlarm' || vm.$route.path === '/eventMonitor') { // 事件处理 /eventMonitor 健康监控 页面
              vm.golobleObject.updateTableAlarm()
            }
            if (vm.$route.path === '/monitor') { // 运营看板
              vm.golobleObject.kindAlarmLine(msgJSON) // 报警趋势
            }
          })
          if (vm.$route.path === '/monitor' || vm.$route.path === '/dataScreen') {
            // console.log('收到报警信息', msg)
            vm.golobleObject.getMqttNewData(msgJSON) // 地图 mqtt获取数据
          }
        }
      }
    })
  }
}

// 关闭订阅（退出登录时调用）
export const closeSub = () => {
  client && client.end()
  client = null
  console.log('关闭mqtt成功')
}

export const sendSub = (topic, msg) => {
  // console.log(topic, msg)
  client.publish(topic, msg)
}

export function unsubjcribe (topic) {
  console.log('关闭', topic)
  client.unsubscribe(topic)
}

export function subscribeSub (topic) {
  console.log('订阅', topic)
  client.subscribe(topic)
}



// WEBPACK FOOTER //
// ./src/mq/index.js